import { FC } from 'react'
import { SectionAwardArticlesProps } from '@portfolio/models'
import { SectionWrapper, Slider } from '@portfolio/components'
import { styled } from '@portfolio/styles'
import { ArticleCard } from './ArticleCard'

const Container = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$64',

  '@lg': {
    paddingInline: '$32',
  },
})

const Title = styled('h2', {
  projectFont: 'heading04',
  color: '$white',
  textAlign: 'center',
  paddingInline: '$24',

  '@lg': {
    paddingInline: 0,
  },
})

const ArticlesContainer = styled('div', {
  display: 'grid',
  gap: 20,

  '@lg': {
    gridTemplateColumns: 'repeat(3, auto)',
    justifyContent: 'center',
    gridAutoFlow: 'column',
  },
})

const DesktopVisibilityContainer = styled('div', {
  display: 'none',

  '@lg': {
    display: 'block',
  },
})
const MobileVisibilityContainer = styled('div', {
  display: 'block',

  '@lg': {
    display: 'none',
  },
})

export const SectionAwardArticles: FC<SectionAwardArticlesProps> = ({
  title,
  spacing,
  topBorder,
  articles,
}) => {
  return (
    <SectionWrapper type={spacing || 'MEDIUM'} topBorder={topBorder}>
      <Container>
        {title && <Title>{title}</Title>}
        <DesktopVisibilityContainer>
          <ArticlesContainer>
            {articles?.map((article) => (
              <ArticleCard
                key={article._key}
                article={article.articleRef}
                shortDescription={article.shortDescription}
                linkLabel={article.linkLabel}
                media={article.media}
                logo={article.logo}
              />
            ))}
          </ArticlesContainer>
        </DesktopVisibilityContainer>
        <MobileVisibilityContainer>
          <Slider isFullWidth>
            {articles?.map((article) => (
              <ArticleCard
                key={article._key}
                article={article.articleRef}
                shortDescription={article.shortDescription}
                linkLabel={article.linkLabel}
                media={article.media}
                logo={article.logo}
              />
            ))}
          </Slider>
        </MobileVisibilityContainer>
      </Container>
    </SectionWrapper>
  )
}
